<template>
  <!--  教练详情 展示-->
  <div class="coach-detail">
    <!-- 顶部概要 -->
    <div class="detail-summary">
      <span class="summary-name">{{ item.coachName }}</span>
      <el-tag v-if="item.coachPersonageDetails?.sex != null" size="small" type="info">
        {{ item.coachPersonageDetails.sex == 0 ? '女' : '男' }}
      </el-tag>
      <el-tag v-if="item.coachRoster?.staffTypeName" size="small">{{ item.coachRoster.staffTypeName }}</el-tag>
    </div>

    <div class="detail-grid">
      <!-- 左列：个人基础信息 -->
      <div class="detail-col">
        <div class="section-title">个人基础信息</div>
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="姓名">{{ item.coachName }}</el-descriptions-item>
          <el-descriptions-item label="民族">{{ item.coachPersonageDetails?.nationName || '—' }}</el-descriptions-item>
          <el-descriptions-item label="婚姻状态">{{
              item.coachPersonageDetails?.isMarriage == 0 ? '未婚' : (item.coachPersonageDetails?.isMarriage == 1 ? '已婚' : '—')
            }}
          </el-descriptions-item>
          <el-descriptions-item label="生日">{{
              (item.coachPersonageDetails?.birthdayType == 0 ? '阴历' : '阳历') + ' - ' + (item.coachPersonageDetails?.birthday || '—')
            }}
          </el-descriptions-item>
          <el-descriptions-item label="身份证号">{{ item.coachPersonageDetails?.identity || '—' }}</el-descriptions-item>
          <el-descriptions-item label="个人电话">{{
              item.coachPersonageDetails?.personagePhone || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="个人邮箱">{{ item.coachPersonageDetails?.mailbox || '—' }}</el-descriptions-item>
        </el-descriptions>

        <div class="section-title">银行信息</div>
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="开户银行">{{ item.coachPersonageDetails?.bankName || '—' }}</el-descriptions-item>
          <el-descriptions-item label="办卡姓名">{{
              item.coachPersonageDetails?.attributionName || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="办卡电话">{{ item.coachPersonageDetails?.bankPhone || '—' }}</el-descriptions-item>
          <el-descriptions-item label="银行卡号">{{
              item.coachPersonageDetails?.bankCardNumbers || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="支行名称">{{ item.coachPersonageDetails?.branch || '—' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 关联银行卡 -->
        <div v-for="(bank, index) in item.partnerBanks" :key="index" class="partner-bank">
          <div class="partner-bank-title">关联银行卡 {{ index + 1 }}</div>
          <el-descriptions :column="1" border size="small">
            <el-descriptions-item label="开户银行">{{ bank.bankName || '—' }}</el-descriptions-item>
            <el-descriptions-item label="银行卡号">{{ bank.bankCardNumbers || '—' }}</el-descriptions-item>
            <el-descriptions-item label="绑定姓名">{{ bank.attributionName || '—' }}</el-descriptions-item>
            <el-descriptions-item label="绑定电话">{{ bank.bankPhone || '—' }}</el-descriptions-item>
            <el-descriptions-item label="绑定身份证">{{ bank.identity || '—' }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="section-title">联系与住址</div>
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="紧急联系人">{{
              item.coachPersonageDetails?.emergencyContact || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="联系人关系">{{
              item.coachPersonageDetails?.emergencyContactRelation || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="联系人电话">{{
              item.coachPersonageDetails?.emergencyContactPhone || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="现住地址">{{
              formatAddr(item.coachPersonageDetails?.thisAddress)
            }}
          </el-descriptions-item>
          <el-descriptions-item label="现住详细地址">{{
              item.coachPersonageDetails?.thisDetailedAddress || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="户籍地址">{{
              formatAddr(item.coachPersonageDetails?.registeredResidenceSite)
            }}
          </el-descriptions-item>
          <el-descriptions-item label="户籍详细地址">{{
              item.coachPersonageDetails?.registeredResidenceDetailedAddress || '—'
            }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="section-title">个人简历</div>
        <div class="resume-box">{{ item.coachPersonageDetails?.individualResume || '暂无' }}</div>

        <!-- 教育经历(放到左栏底部,填掉两栏不对齐产生的空白) -->
        <div class="section-title">教育经历</div>
        <template v-if="item.coachEducationList && item.coachEducationList.length > 0">
          <el-descriptions v-for="(education, index) in item.coachEducationList" :key="index" :column="3" border
                           size="small" class="education-item">
            <el-descriptions-item label="毕业院校">{{ education.schoolName || '—' }}</el-descriptions-item>
            <el-descriptions-item label="专业">{{ education.major || '—' }}</el-descriptions-item>
            <el-descriptions-item label="学历">{{ education.educationRankIdName || '—' }}</el-descriptions-item>
            <el-descriptions-item label="毕业时间">{{ education.graduateTime || '—' }}</el-descriptions-item>
            <el-descriptions-item label="学历类型">{{ education.isFullTimeName || '—' }}</el-descriptions-item>
          </el-descriptions>
        </template>
        <div v-else style="color:#909399;padding: 8px 0">暂无教育经历</div>

        <div class="section-title">工作信息</div>
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="ID">{{ item.coachId }}</el-descriptions-item>
          <el-descriptions-item label="工号">{{ item.workNumber || '—' }}</el-descriptions-item>
          <el-descriptions-item label="工作电话">{{ item.coachPhone || '—' }}</el-descriptions-item>
          <el-descriptions-item label="所属部门">{{ item.deptName || '—' }}</el-descriptions-item>
          <el-descriptions-item label="所属校区">{{
              item.campusName ? item.campusName + '-' + item.flagName : '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="可见校区">
            <el-cascader
                size="small"
                style="width: 220px"
                placeholder="点击查看可见校区"
                :options="item.areaNameList"
                filterable
                :props="{value: 'id', label: 'name', children: 'children'}"
            />
          </el-descriptions-item>
          <el-descriptions-item label="管辖校区">
            <el-cascader
                size="small"
                style="width: 220px"
                placeholder="点击查看管辖校区"
                :options="areaTree"
                collapse-tags
                collapse-tags-tooltip
                :props="{value: 'id', label: 'name', children: 'children', multiple: true, emitPath: false}"
                v-model="adminAreaIds"
            />
          </el-descriptions-item>
          <el-descriptions-item label="拥有角色">
            <div class="tag-wrap">
              <el-tag v-for="role in item.roles" :key="role.name" size="small" class="area-tag">{{ role.name }}</el-tag>
              <span v-if="!item.roles || item.roles.length === 0" style="color:#909399">—</span>
            </div>
          </el-descriptions-item>
        </el-descriptions>


      </div>

      <!-- 右列：工作信息 -->
      <div class="detail-col">

        <div class="section-title">人事与合同</div>
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="合同类型">{{ item.coachRoster?.contractTypeName || '—' }}</el-descriptions-item>
          <el-descriptions-item label="员工状态">{{ item.coachRoster?.staffTypeName || '—' }}</el-descriptions-item>
          <el-descriptions-item label="工龄">{{ item.coachRoster?.yearsOfWorking ?? '—' }}</el-descriptions-item>
          <el-descriptions-item label="司龄">{{ item.coachRoster?.companyAge ?? '—' }}</el-descriptions-item>
          <el-descriptions-item label="首次工作日期">{{ item.coachRoster?.theFirstWorkDate || '—' }}</el-descriptions-item>
          <el-descriptions-item label="入职日期">{{ item.coachRoster?.entryDate || '—' }}</el-descriptions-item>
          <el-descriptions-item label="工作地点">{{ item.coachRoster?.workplaceName || '—' }}</el-descriptions-item>
          <el-descriptions-item label="合同签署主体">{{
              item.coachRoster?.signContractFirstPartyName || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item label="合同开始日期">{{ item.coachRoster?.contractStartTime || '—' }}</el-descriptions-item>
          <el-descriptions-item label="合同结束日期">{{ item.coachRoster?.contractEndTime || '—' }}</el-descriptions-item>
        </el-descriptions>
        <!-- 转正/离职 -->
        <div v-if="item.coachOfficialApply.applyDate && item.coachOfficialApply.officialDate" class="apply-box">
          <div class="apply-box-title">转正信息</div>
          <div>转正申请时间：{{ item.coachOfficialApply.applyDate || '—' }}</div>
          <div>转正时间：{{ item.coachOfficialApply.officialDate || '—' }}</div>
        </div>
        <div v-else  class="apply-box">
          <div class="apply-box-title">试用期</div>
        </div>
        <div v-if="item.coachDimissionApply.applyDate && item.coachDimissionApply.dimissionDate" class="apply-box">
          <div class="apply-box-title">离职信息</div>
          <div>离职申请时间：{{ item.coachDimissionApply.applyDate || '—' }}</div>
          <div>离职时间：{{ item.coachDimissionApply.dimissionDate || '—' }}</div>
          <div>离职原因：{{ item.coachDimissionApply.dimissionCause || '—' }}</div>
        </div>
        <div v-else-if="item.state==='开启'" class="apply-box" >
          <div  class="apply-box-title">在职</div>
        </div>

        <!-- 签字结果 -->
        <div class="section-title">签字结果</div>
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="当前已确认图片">
            <el-image
                v-if="signUrl"
                :src="signUrl"
                fit="contain"
                class="sign-img"
                :preview-src-list="[signUrl]"
                preview-teleported
            >
              <template #error>
                <span style="color:#909399;font-size:12px">图片加载失败</span>
              </template>
            </el-image>
            <span v-else style="color:#909399">暂无签字</span>
          </el-descriptions-item>
          <el-descriptions-item label="签字时间">{{ signTime || '—' }}</el-descriptions-item>

        </el-descriptions>

        <div v-if="item.signReview!=null">
          <div class="section-title">签字待审核</div>
          <el-descriptions :column="1" border size="small">
            <el-descriptions-item label="签字待审核">
              <el-image
                  v-if="signReviewUrl"
                  :src="signReviewUrl"
                  fit="contain"
                  class="sign-img"
                  :preview-src-list="[signReviewUrl]"
                  preview-teleported
              >
                <template #error>
                  <span style="color:#909399;font-size:12px">图片加载失败</span>
                </template>
              </el-image>
              <span v-else style="color:#909399">暂无签字</span>
            </el-descriptions-item>
            <el-descriptions-item label="审核状态">
              <el-tag v-if="signReview" :type="signTagType" size="small">
                {{ signStateStr }}
              </el-tag>
              <span v-else style="color:#909399">—</span>
            </el-descriptions-item>
            <el-descriptions-item label="审核人">{{ (signReview && signReview.auditorName) || '—' }}</el-descriptions-item>
            <el-descriptions-item label="签字提交时间">{{
                (signReview && signReview.createTime) || '—'
              }}
            </el-descriptions-item>
            <el-descriptions-item label="审核时间">{{
                (signReview && signReview.auditorTime) || '—'
              }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 签字审核操作(人资/技术部门可见,待审核时才显示) -->
        <div v-if="canReview" class="sign-review-actions">
          <el-button type="success" size="small" @click="handleReview(1)">审核通过</el-button>
          <el-button type="danger" size="small" @click="handleReview(2)">审核不通过</el-button>
        </div>

        <div style="margin-top: 16px">
          <el-button type="primary" plain @click="searchContarct">查看合同列表</el-button>
        </div>
      </div>
    </div>
  </div>

  <!--  合同列表弹框-->
  <el-dialog title="合同列表" v-model="listDialog" width="800px">
    <el-table :data="List" border>
      <el-table-column prop="id" label="Id"/>
      <el-table-column prop="signContractFirstPartyName" label="劳务合同主体"/>
      <el-table-column prop="contractTypeName" label="合同类型"/>
      <el-table-column prop="contractStartTime" label="合同开始时间"/>
      <el-table-column prop="contractEndTime" label="合同结束时间"/>
      <el-table-column prop="contractNumTypeName" label="合同当前状态">
        <template #default="scope">
          <el-tag :type="scope.row.contractNumType === 1 ? '' : 'danger'">
            {{ scope.row.contractNumTypeName }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="primary" plain @click="UpdateContract(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

  <!--修改教练合同信息-->
  <el-dialog title="修改教练合同信息" v-model="dialogUpdateContractVisible" width="500">
    <el-date-picker
        v-model="contractStartEnd"
        @change="selectStartEndDate"
        type="datetimerange"
        range-separator="-"
        start-placeholder="合同开始时间"
        end-placeholder="合同截止时间"
        format="YYYY-MM-DD"
        date-format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
    />
    <el-button type="primary" plain @click="doUpdateContract()">修改</el-button>
  </el-dialog>
</template>

<script>
import {selectCoachContractByCoachId} from '@/api/coach.js'
import {updateCoachContractDate} from "@/api/coachRoster";
import {listAreaTreeAddCoach} from "@/api/area.js";
import {selectDeptList} from "@/api/dept";
import {passSignReview} from "@/api/signReview";

export default {
  name: "CoachDetail",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      listDialog: false,//合同列表弹框 是否显示
      List: [],//教练详情列表数据
      dialogUpdateContractVisible: false,//修改合同弹框
      contractItem: null,//修改的合同值
      contractStartEnd: () => {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        return [start, end]
      },//默认合同开始时间结束时间
      areaTree: [],//全量区域树(省份-城市-校区),用于管辖校区树状展示
      reviewDeptIds: [],//可审核签字的部门ID集合(按名称匹配: 技术部/人事行政部)
      signReviewLocal: null,//本地审核状态(审核操作后即时刷新用)
    }
  },
  computed: {
    //签字图(来自表格行 item.coachRoster, 后端按 coachId 直查)
    signUrl() {
      return this.item?.coachRoster?.signUrl || '';
    },
    //计算属性
    signReviewUrl() {
      return this.item?.signReview?.signUrl || '';
    },
    //签字时间
    signTime() {
      return this.item?.coachRoster?.signTime || '';
    },
    //签字审核对象:优先本地已更新的状态,否则取后端返回
    signReview() {
      return this.signReviewLocal || this.item?.coachRoster?.signReview || this.item?.signReview || null;
    },
    //审核状态文案:优先后端返回的 stateStr,否则按 state 本地映射
    signStateStr() {
      const s = this.signReview;
      if (!s) return '—';
      if (s.stateStr) return s.stateStr;
      const state = Number(s.state);
      if (state === 0) return '审核中';
      if (state === 1) return '审核通过';
      if (state === 2) return '审核不通过';
      return '—';
    },
    //审核状态标签类型: 0审核中=warning 1通过=success 2不通过=danger
    signTagType() {
      const s = this.signReview;
      if (!s) return 'info';
      const state = Number(s.state);
      if (state === 0) return 'warning';
      if (state === 1) return 'success';
      if (state === 2) return 'danger';
      return 'info';
    },
    //当前登录用户是否为 人资/技术 部门(可审核签字)
    isReviewUser() {
      const deptId = Number(localStorage.getItem('deptId'));
      return this.reviewDeptIds.includes(deptId);
    },
    //是否显示审核按钮: 存在待审核记录(state=0) 且 当前用户具备审核权限
    canReview() {
      const s = this.signReview;
      return !!s && Number(s.state) === 0 && this.isReviewUser;
    },
    //管辖校区ID集合(树状级联 v-model)
    adminAreaIds: {
      get() {
        return Array.isArray(this.item?.adminAreaList) ? this.item.adminAreaList : [];
      },
      set() {
        //详情为只读展示,不修改
      }
    }
  },
  created() {
    this.loadAreaTree();
    this.loadReviewDepts();
  },
  methods: {
    /**
     * 加载全量区域树(省份-城市-校区),供管辖校区级联展示
     */
    loadAreaTree() {
      listAreaTreeAddCoach().then(val => {
        if (val && val.code === 200 && Array.isArray(val.data)) {
          this.areaTree = val.data;
        }
      }).catch(err => {
        console.error('[CoachDetail] 加载区域树失败:', err);
      })
    },
    /**
     * 加载部门列表,按名称匹配"技术部/人事行政部"(人资),得到可审核签字的部门ID集合
     * 用 selectDeptList(全量部门,不受当前用户管辖范围过滤)而非 listXcxDept(会被按管辖过滤,
     * 非 sys 身份用户可能拿不到技术部等上层部门,导致匹配失败)
     */
    loadReviewDepts() {
      selectDeptList().then(res => {
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.reviewDeptIds = res.data
              .filter(d => d && d.name && /技术部|人事行政部|人资/.test(d.name))
              .map(d => Number(d.id));
        }
      }).catch(err => {
        console.error('[CoachDetail] 加载部门列表失败:', err);
      })
    },
    /**
     * 签字审核操作
     * @param state 1=审核通过 2=审核不通过
     */
    handleReview(state) {
      const s = this.signReview;
      if (!s) return;
      const actionText = state === 1 ? '审核通过' : '审核不通过';
      this.$confirm(`确定对该教练的手写签字${actionText}吗？`, '签字审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: state === 1 ? 'success' : 'warning'
      }).then(() => {
        passSignReview({
          id: s.id,
          coachId: s.coachId,
          signUrl: s.signUrl,
          state: state
        }).then(res => {
          if (res && res.code === 200) {
            this.$message.success(actionText + '成功');
            //本地即时刷新审核状态,无需重新拉列表
            this.signReviewLocal = {
              ...s,
              state: state,
              stateStr: actionText,
              auditorName: localStorage.getItem('ms_username') || '',
              auditorTime: this.nowTime()
            };
          } else {
            this.$message.error(actionText + '失败：' + (res && res.message ? res.message : '请稍后重试'));
          }
        }).catch(err => {
          console.error('[CoachDetail] 签字审核异常:', err);
          this.$message.error(actionText + '失败，请检查网络后重试');
        })
      }).catch(() => {
        //取消审核
      })
    },
    nowTime() {
      const now = new Date();
      const p = (n) => String(n).padStart(2, '0');
      return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())} ${p(now.getHours())}:${p(now.getMinutes())}:${p(now.getSeconds())}`;
    },
    //数组地址转字符串
    formatAddr(val) {
      if (Array.isArray(val)) return val.join('');
      return val || '—';
    },
    //时间切换后
    selectStartEndDate() {
      if (this.contractStartEnd && this.contractStartEnd.length > 0) {
        this.contractItem.contractStartTime = this.contractStartEnd[0]
        this.contractItem.contractEndTime = this.contractStartEnd[1]
      }
    },
    //点击确定修改
    doUpdateContract() {
      // console.log(this.contractStartEnd)
      //执行合同有效期修改
      updateCoachContractDate(this.contractItem).then(res => {
        this.dialogUpdateContractVisible = false
        if (res.code === 200) {
          this.$message.success('修改成功')
          //刷新
          this.searchContarct();
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //修改合同
    UpdateContract(contractItem) {
      //设置到修改的对象
      this.contractItem = contractItem;
      this.contractStartEnd = [contractItem.contractStartTime, contractItem.contractEndTime]
      this.dialogUpdateContractVisible = true
    },
    //查询合同
    searchContarct() {
      selectCoachContractByCoachId(this.item.coachId).then(res => {
        if (res.code === 200) {
          this.listDialog = true
          this.List = res.data
        } else {
          this.$message.error('获取合同列表失败！')
        }
      })
    }
  }
}
</script>

<style scoped>
.coach-detail {
  padding: 4px 8px 16px;
}

/* 顶部概要 */
.detail-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  margin-bottom: 4px;
  background: linear-gradient(90deg, #f0f7ff, #fafcff);
  border: 1px solid #e4ecf7;
  border-radius: 8px;
}

.summary-name {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

/* 左右两栏 */
.detail-grid {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.detail-col {
  flex: 1;
  min-width: 400px;
}

/* 区块标题 */
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 18px 0 10px 0;
  padding-left: 10px;
  border-left: 3px solid #409eff;
  line-height: 1.4;
}

/* 关联银行卡卡片 */
.partner-bank {
  background: #f7f9fc;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  padding: 8px 12px 4px;
  margin-top: 10px;
}

.partner-bank-title {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 6px;
}

/* 简历:多数教练无简介,高度自适应内容,不预设最小高度避免大片留白 */
.resume-box {
  background: #f7f9fc;
  border-radius: 8px;
  padding: 10px 14px;
  white-space: pre-wrap;
  color: #303133;
  line-height: 1.7;
  min-height: 0;
}

/* 转正/离职 */
.apply-box {
  background: #fdf6ec;
  border: 1px solid #f5e4c5;
  border-radius: 8px;
  padding: 10px 14px;
  margin-top: 12px;
  color: #606266;
  font-size: 13px;
  line-height: 1.9;
}

.apply-box-title {
  font-weight: 600;
  color: #b88230;
  margin-bottom: 4px;
}

/* 标签 */
.tag-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.area-tag {
  margin: 2px 0;
}

/* 签字图:宽度加倍便于看清签字内容, contain 完整展示不裁切 */
.sign-img {
  width: 144px;
  height: 144px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  background: #fff;
  cursor: pointer;
}

/* 签字审核按钮区 */
.sign-review-actions {
  margin-top: 12px;
  display: flex;
  gap: 10px;
}

/* 教育经历 */
.education-item {
  margin-bottom: 8px;
}

:deep(.el-descriptions__label) {
  font-weight: 500;
  background-color: #fafafa;
}

:deep(.el-descriptions--small .el-descriptions__cell) {
  padding: 6px 10px;
}
</style>
